import { defineMessages } from "react-intl";

export default defineMessages({
  genetiivi: {
    id: "vapaaSivistystyo.genetiivi",
    defaultMessage: "Vapaan sivistystyön"
  },
  kebabCase: {
    id: "vapaaSivistystyo.kebabCase",
    defaultMessage: "vapaa-sivistystyo"
  },
  kuvausteksti: {
    id: "vapaaSivistystyo.kuvausteksti",
    defaultMessage:
      "Vapaan sivistystyön oppilaitoksia ovat kansalaisopistot, kansanopistot, kesäyliopistot, liikunnan koulutuskeskukset ja opintokeskukset. Opetus- ja kulttuuriministeriö voi myöntää kunnalle, kuntayhtymälle, rekisteröidylle yhteisölle tai säätiölle luvan vapaan sivistystyön oppilaitoksen ylläpitämiseen. Tällä sivulla voit tarkastella oppilaitosten ylläpitäjiä ja heidän ylläpitämislupiaan."
  },
  lyhytKuvaus: {
    id: "vapaaSivistystyo.lyhytKuvaus",
    defaultMessage:
      "Vapaan sivistystyön oppilaitoksia ovat kansalaisopistot, kansanopistot, kesäyliopistot, liikunnan koulutuskeskukset ja opintokeskukset. Opetus- ja kulttuuriministeriö voi myöntää kunnalle, kuntayhtymälle, rekisteröidylle yhteisölle tai säätiölle luvan vapaan sivistystyön oppilaitoksen ylläpitämiseen. Tällä sivulla voit tarkastella oppilaitosten ylläpitäjiä ja heidän ylläpitämislupiaan."
  },
  paasivunOtsikko: {
    id: "vapaaSivistystyo.paasivunOtsikko",
    defaultMessage: "Vapaan sivistystyön oppilaitosten ylläpitäjät"
  },
  esittelyteksti: {
    id: "vapaaSivistystyo.esittelyteksti",
    defaultMessage:
      "Tälle sivulle on koottu oppilaitoksen ylläpitämisluvan perustiedot. Ylläpitämislupa löytyy alkuperäisenä kokonaisuudessaan Päätökset-välilehdeltä."
  },
  voimassaOlevatYllapitamisluvat: {
    id: "vapaaSivistystyo.voimassaOlevatYllapitamisluvat",
    defaultMessage: "Voimassa olevat ylläpitämisluvat {count} kpl"
  },
  voimassaOlevatYllapitamisluvatSuluissa: {
    id: "vapaaSivistystyo.voimassaOlevatYllapitamisluvatSuluissa",
    defaultMessage: "Voimassa olevat ylläpitämisluvat ({amount} kpl)"
  },
  yllapitajanNimiJaKotipaikka: {
    id: "vapaaSivistystyo.yllapitajanNimiJaKotipaikka",
    defaultMessage: "Ylläpitäjän nimi ja kotipaikka"
  },
  oppilaitoksenNimiJaSijainti: {
    id: "vapaaSivistystyo.oppilaitoksenNimiJaSijainti",
    defaultMessage: "Oppilaitoksen nimi ja sijainti"
  },
  oppilaitoksenNimiJaSijaintiInfo: {
    id: "vapaaSivistystyo.oppilaitoksenNimiJaSijaintiInfo",
    defaultMessage:
      "Et voi muuttaa näitä tietoja Oiva-palvelussa. Halutessasi muuttaa tietoja sinun tulee olla yhteydessä Opetushallituksen organisaatiopalveluun yhteisetpalvelut@opintopolku.fi"
  },
  jarjestamislupa: {
    id: "vapaaSivistystyo.jarjestamislupa",
    defaultMessage: "Vapaan sivistystyön järjestämislupa"
  }
});
